import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import '../models/DatasetsModal';
import { Data } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DatasetService {
  appURL = environment.appURL;

  constructor(private http: HttpClient) { }

  getDataSetListByID(id: string) {
    return this.http.get<DataSetListData>(`${this.appURL}/accounts/${id}/datasets`);
  }

  getUploadedDataSetFiles(id: string, enrollmentId: string) {
    return this.http.get<DataSetSourcesList>(`${this.appURL}/accounts/configurations/datasets/sources?enrollmentId=${enrollmentId}&accountId=${id}`);
  }

  getdatasetById(datasetId: string) {
    return this.http.get<DataSetData>(`${this.appURL}/accounts/${datasetId}/datasets/details`);
  }


  getNewDatasetFrom(fileName: string) {
    return this.http.get<DataSetData>(`${this.appURL}/accounts/configurations/datasets/${fileName}`);
  }

  createDataset(body: DatasetFromRequest) {
    return (this.http.post<DatasetFromResponse>(`${this.appURL}/accounts/custom-data-sets`, body));
  }

  updateDataset(body: DatasetFromRequest, accountId: string, ) {
    return of("");
    // return (this.http.post<DatasetFromRequest>(`${this.appURL}/accounts/${accountId}/custom-data-sets`, body));
  }

}
